 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"styles","7":"vendors~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_h~c242384b","8":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~786c2677","10":"vendors~AuthNew~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~1ac49a88","11":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~57c40635","12":"vendors~AuthNew~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mo~ee92ece2","13":"vendors~Header~about~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~~fd67083c","15":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~79646d14","16":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~2a013cce","19":"authVendor","21":"vendors~AuthNew~Cigarette~ClientFormContainer~client~modern_desktop_home~modern_mobile_home~order_ch~b1b2f2cd","22":"vendors~AuthNew~Cigarette~ClientFormContainer~client~order_changing_request~search~seo_page~testimonials","23":"vendors~Cigarette~Header~about~client~header_app~modern_desktop_home~modern_mobile_home~testimonials","24":"vendors~Header~about~header_app~hotels~modern_desktop_home~modern_mobile_home~testimonials","26":"vendors~Header~about~header_app~modern_desktop_home~modern_mobile_home","28":"Header~about~header_app","29":"AuthNew~ClientFormContainer","30":"FiltersPanel","31":"Map~YandexMapsSearch","34":"vendors~AuthNew~ClientFormContainer","36":"AboutRoomPopup","37":"AndroidIcon","38":"AuthNew","39":"Cigarette","40":"ClientFormContainer","41":"DesktopAppBanner","42":"EmptyFiltration","43":"EmptyMap","44":"EmptySearch","45":"FiltersPanelMobile","46":"FlightsItem","47":"FloatingPanelMobile","48":"Header","49":"HeaderAuth","50":"HotelMap","51":"HotelMapMarker","52":"IosIcon","53":"Map","54":"Mapbox","55":"MountainsContainer","56":"NpsForm","57":"PriceChart","58":"SearcherEmpty","59":"SimilarPackagesContainer","60":"Subscribe","61":"ToAppgallery","62":"ToRustore","63":"YandexHotelMap","64":"YandexMapsSearch","89":"vendors~AboutRoomPopup","90":"vendors~Cigarette","91":"vendors~DesktopAppBanner","92":"vendors~EmptySearch","93":"vendors~HeaderAuth","94":"vendors~HotelMap","95":"vendors~HotelNotice","96":"vendors~Subscribe"}[chunkId]||chunkId) + ".__" + {"1":"098f839111407cc1e494","7":"dbc9f3b894e49a57e237","8":"56397857f72e13ca4bdc","10":"b9dab6227e5b58feda93","11":"962ac28a9f0b1fa7c682","12":"4182cee582b248b29b70","13":"22510c346d5dab45724b","15":"8907e9dc29a1e20b46a7","16":"f19f2f025b82538ebb0d","19":"7924ecc34d1ae78778f0","21":"ca74f5f56fc13d15cefa","22":"5cedb1c74550e0f216a8","23":"65cc02c9154ca557c779","24":"f4d450c7a92cc1bd1f94","26":"72d5423a23c70e10019b","28":"00367d89994a5d8beffd","29":"9488626aaa5962e1515d","30":"3a62d300f6fa3474442a","31":"2f49179848c7a2e1ae8e","34":"2b1db0eb497d585818c2","36":"cf6eb4d5844f2e990384","37":"63b3a52a844b8d986afa","38":"d50517a524d9b5f95ec5","39":"d589b8783bf495454f63","40":"dff17eb15ccadddafce5","41":"7ef6f70dd9c43e6878a1","42":"54264f655ed26512cf9f","43":"f460bde9f50824a6175e","44":"095b4e198fc51bda06ca","45":"e890df06fcc639873222","46":"11b0922f1cbb1386bd07","47":"8e820580837de9bd2bc1","48":"2c6c74dbd6b62f2ca2eb","49":"5fa99cf8db2752e870cd","50":"c72240da5b6893a63f81","51":"3499e88ff7511f74d64c","52":"1b09b346b99986e062b1","53":"481af1fcd8444f8272de","54":"e2e434888642aed2bb28","55":"781359d4ef393d94e15b","56":"a83afa6f7710f4754e8a","57":"7141f342674d12b39f10","58":"85231699a95cbeccecfb","59":"46395a7cf7ee83730801","60":"9cd8163543cee86907f4","61":"9b0180178560644c5c5e","62":"7ad0c53ab16584321c09","63":"2efb44e5ed6e647bd3ad","64":"4dd0a47eef32ef06870f","89":"bb9dbbd847cd986c3f17","90":"56de1ee9f8471f39e68f","91":"358c49938a2b3ef76802","92":"a23cfd7554b12904fd8a","93":"732233e1441caca6f635","94":"4e29ec4318092952a777","95":"21b3bd633c93865b7464","96":"9dc9fc44f58f442fd746"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"styles","7":"vendors~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_h~c242384b","8":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~786c2677","10":"vendors~AuthNew~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~1ac49a88","11":"vendors~Header~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mod~57c40635","12":"vendors~AuthNew~about~client~gift_certificate~header_app~hotel_checkout~hotel_reviews_page~hotels~mo~ee92ece2","13":"vendors~Header~about~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desktop_home~~fd67083c","15":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~79646d14","16":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~2a013cce","19":"authVendor","21":"vendors~AuthNew~Cigarette~ClientFormContainer~client~modern_desktop_home~modern_mobile_home~order_ch~b1b2f2cd","22":"vendors~AuthNew~Cigarette~ClientFormContainer~client~order_changing_request~search~seo_page~testimonials","23":"vendors~Cigarette~Header~about~client~header_app~modern_desktop_home~modern_mobile_home~testimonials","24":"vendors~Header~about~header_app~hotels~modern_desktop_home~modern_mobile_home~testimonials","26":"vendors~Header~about~header_app~modern_desktop_home~modern_mobile_home","28":"Header~about~header_app","29":"AuthNew~ClientFormContainer","30":"FiltersPanel","31":"Map~YandexMapsSearch","34":"vendors~AuthNew~ClientFormContainer","36":"AboutRoomPopup","37":"AndroidIcon","38":"AuthNew","39":"Cigarette","40":"ClientFormContainer","41":"DesktopAppBanner","42":"EmptyFiltration","43":"EmptyMap","44":"EmptySearch","45":"FiltersPanelMobile","46":"FlightsItem","47":"FloatingPanelMobile","48":"Header","49":"HeaderAuth","50":"HotelMap","51":"HotelMapMarker","52":"IosIcon","53":"Map","54":"Mapbox","55":"MountainsContainer","56":"NpsForm","57":"PriceChart","58":"SearcherEmpty","59":"SimilarPackagesContainer","60":"Subscribe","61":"ToAppgallery","62":"ToRustore","63":"YandexHotelMap","64":"YandexMapsSearch","89":"vendors~AboutRoomPopup","90":"vendors~Cigarette","91":"vendors~DesktopAppBanner","92":"vendors~EmptySearch","93":"vendors~HeaderAuth","94":"vendors~HotelMap","95":"vendors~HotelNotice","96":"vendors~Subscribe"}[chunkId]||chunkId) + "." + {"1":"e34e0f3c79c3c1952bd2","7":"d41d8cd98f00b204e980","8":"d41d8cd98f00b204e980","10":"d41d8cd98f00b204e980","11":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","13":"d41d8cd98f00b204e980","15":"d41d8cd98f00b204e980","16":"d41d8cd98f00b204e980","19":"d41d8cd98f00b204e980","21":"d41d8cd98f00b204e980","22":"d41d8cd98f00b204e980","23":"d41d8cd98f00b204e980","24":"d41d8cd98f00b204e980","26":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","29":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","31":"d41d8cd98f00b204e980","34":"d41d8cd98f00b204e980","36":"d41d8cd98f00b204e980","37":"d41d8cd98f00b204e980","38":"d41d8cd98f00b204e980","39":"d41d8cd98f00b204e980","40":"d41d8cd98f00b204e980","41":"d41d8cd98f00b204e980","42":"d41d8cd98f00b204e980","43":"d41d8cd98f00b204e980","44":"d41d8cd98f00b204e980","45":"d41d8cd98f00b204e980","46":"d41d8cd98f00b204e980","47":"d41d8cd98f00b204e980","48":"d41d8cd98f00b204e980","49":"d41d8cd98f00b204e980","50":"d41d8cd98f00b204e980","51":"d41d8cd98f00b204e980","52":"d41d8cd98f00b204e980","53":"d41d8cd98f00b204e980","54":"d41d8cd98f00b204e980","55":"d41d8cd98f00b204e980","56":"d41d8cd98f00b204e980","57":"d41d8cd98f00b204e980","58":"d41d8cd98f00b204e980","59":"d41d8cd98f00b204e980","60":"d41d8cd98f00b204e980","61":"d41d8cd98f00b204e980","62":"d41d8cd98f00b204e980","63":"d41d8cd98f00b204e980","64":"d41d8cd98f00b204e980","89":"d41d8cd98f00b204e980","90":"d41d8cd98f00b204e980","91":"d41d8cd98f00b204e980","92":"d41d8cd98f00b204e980","93":"d41d8cd98f00b204e980","94":"d41d8cd98f00b204e980","95":"d41d8cd98f00b204e980","96":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
